
export enum AgeGateEvents {
    VERIFIED = 'ageVerified'
}

export enum PageAgeGateEvents {
    VERIFIED = 'PageAgeGateVerified',
    VERIFYING = 'PageAgeGateVerifying',
    FAILED = 'PageAgeGateFailed',
}
